var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-4"},[(_vm.localValue)?_c('v-icon',{on:{"click":_vm.toggleZeroSalesPrice}},[_vm._v(" mdi-currency-eur-off ")]):_c('v-icon',{on:{"click":_vm.toggleZeroSalesPrice}},[_vm._v(" mdi-currency-eur ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }